import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson4: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.88rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between text-[1.56rem]">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson3"}>
          <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Mindset Types</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson5"}>
          <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Types of Mindset</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  It is the eternal battle between good and evil that exists
                  within us. The way you are conditioned determines how you
                  think, how you judge, and how you react and act based on it.
                  There are two types of mindsets: a growth mindset and a fixed
                  mindset.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  It is not that you have either a fixed or a growth mindset in
                  all cases. One is always dominant, but in daily practice, we
                  move between the two extremes. Sometimes you will be very
                  adamant (fixed) from your conditioning, while at other times
                  you will be receptive and open to a new vision.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[25.81rem] h-[25.81rem] object-cover"
            alt=""
            src="/4@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Fixed Mindset</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  People with a fixed mindset believe that intelligence,
                  personality, and character are outstanding facts. You are
                  boarded with them; they cannot be developed. From this
                  perspective, you are smart or stupid, talented or average.
                  People with fixed mindsets are focused on proving themselves.
                  They are quick to think, wrongly, that people have a bad
                  opinion of them. They drop out relatively quickly if something
                  doesn't work out and can then feel frustrated and rejected.
                  They often have a negative self-image because they constantly
                  compare themselves to others who are better. They do not ask
                  themselves what they could learn from those others. People
                  with a fixed attitude want to maintain their acquired position
                  as much as possible and avoid risks. New challenges that pose
                  a potential threat to the position are therefore preferred to
                  be avoided. When things go wrong when they undertake
                  something, they will not readily admit that they were
                  responsible, preferring instead to blame someone else or
                  circumstances. This thinking and living attitude has a very
                  negative effect on self-confidence and self-esteem.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[31.51rem] h-[31.25rem] object-cover"
            alt=""
            src="/5@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Change Your Mindset</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Psychology professor Carol Dweck says: 'Mindsets are beliefs.
                They are strong beliefs, but they are still a way of thinking
                and you can change your thinking. Based on years of research,
                she dares to say that intelligence and personality traits are
                not innate but are largely the result of development and
                practice.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In her book, Mindset, The New Psychology of Success, she also
                cites Alfred Binet, the inventor of the IQ test. That test was
                designed to discover whether children needed extra help, not to
                determine their intelligence level. He claimed that we can
                increase our acuity, memory, insight, and the quality of our
                intelligence through practice, training, and repetition.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you believe that you can develop yourself, you are open to
                precise information about your current capabilities, even if it
                is not very flattering. And if you are focused on learning, you
                need this information to do so effectively. Those with a fixed
                mindset mainly judge information about their abilities as good
                or bad. Those with a limited mindset are afraid of failure
                because it reflects negatively on their basic abilities.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Now it is up to you to analyse your own thinking patterns. In
                which situations is your mindset fixed and when are you more
                growth-oriented?
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson5"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson4;
